<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="lndon"> </p>
<p class="tni"><span class="epub-i">If There Is I Haven’t Found It Yet</span> had its world premiere in London on October 17, 2009, at the Bush Theatre.</p>
<p class="h2"><span class="epub-b">Cast</span></p>
<p class="schar"><span class="epub-sc">GEORGE</span> Michael Begley</p>
<p class="schar"><span class="epub-sc">FIONA</span> Pandora Colin</p>
<p class="schar"><span class="epub-sc">ANNA</span> Ailish O’Connor</p>
<p class="schar"><span class="epub-sc">TERRY</span> Rafe Spall</p>
<p class="h2"><span class="epub-b">Creative Team</span></p>
<p class="schar"><span class="epub-sc">DIRECTOR</span> Josie Rourke</p>
<p class="schar"><span class="epub-sc">DESIGNER</span> Lucy Osborne</p>
<p class="schar"><span class="epub-sc">LIGHTING DESIGNER</span> Oliver Fenwick</p>
<p class="schar"><span class="epub-sc">SOUND DESIGNER</span> Emma Laxton</p>
<p class="schar"><span class="epub-sc">ASSISTANT DIRECTOR</span> Ant Stones</p>
<p class="schar"><span class="epub-sc">COMPANY STAGE MANAGER</span> Angela Riddell</p>
<p class="schar"><span class="epub-sc">DEPUTY STAGE MANAGER</span> Dave Blakemore</p>
<p class="schar"><span class="epub-sc">SCENIC ARTIST</span> Lara Etherton</p>
<p class="schar"><span class="epub-sc">DESIGN ASSISTANT</span> James Turner</p>
<p class="schar"><span class="epub-sc">STAGE MANAGER (COVER)</span> Xenia Lewis</p>
<p class="schar"><span class="epub-sc">PRODUCTION ELECTRICIAN</span> Chole Kenward</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// lond-prod.vue?c3f3127a